import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=b04c405e&scoped=true"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js"
import style0 from "./HamburgerMenu.vue?vue&type=style&index=0&id=b04c405e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04c405e",
  null
  
)

export default component.exports